const passkey_sign_in = {
    setup_page: {
        title: 'Simplify your sign-in',
        subtitle: 'Create a Passkey',
        description: 'Register your Passkey using device biometrics, security keys like YubiKey, or other available methods.',
    },
    trigger_conditional_ui_failed: 'Failed to trigger Passkey autofill.',
};
export default Object.freeze(passkey_sign_in);
